import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarPolyline = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	stroke: "white",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			x1: 6.95548,
			y1: 4.0174,
			x2: 4.05703,
			y2: 7.14036
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 4.32039,
			y1: 8.59159,
			x2: 9.36383,
			y2: 10.2437
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2.60845,
			cy: 8.40533,
			r: 1.99957
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.1299,
			cy: 11.1301,
			r: 1.99957
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.08648,
			cy: 2.60821,
			r: 1.99957
		})
	]
});
export default SvgToolbarPolyline;
